// extracted by mini-css-extract-plugin
export default {"notificationText":"AvailabilityZone_notificationText__jxvpM","deleteButton":"AvailabilityZone_deleteButton__3Z4PN","marginTop":"AvailabilityZone_marginTop__RuxPz"};